import { render } from "./Sales.vue?vue&type=template&id=11c84304"
import script from "./Sales.vue?vue&type=script&lang=js"
export * from "./Sales.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pharmarcy/Sales.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11c84304"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11c84304', __exports__)) {
    api.reload('11c84304', __exports__)
  }
  
  module.hot.accept("./Sales.vue?vue&type=template&id=11c84304", () => {
    api.rerender('11c84304', render)
  })

}


export default __exports__